/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import './css/HomePage1Banner.css';
import { context } from '../../../../../globalState/GlobalState';
import { isValidString } from '../../../../../catalog/Validity';
import { getWebsiteImage, getWebsiteImageLinkFromImageId, openWebsiteImageLinkFromImageId } from '../../../../../catalog/Website';

const HomePage1Banner = (props) => {
    const { imageId } = props;
    const { globalState } = useContext(context);

    const styles = StyleSheet.create({
        image: {
            ':hover': {
                cursor: 'pointer',
            },
        },
    });

    return (
        <>
            {globalState.stylesDownloaded && getWebsiteImage(globalState, imageId) ? (
                <img
                    onClick={() => { openWebsiteImageLinkFromImageId(globalState, imageId); }}
                    className={isValidString(getWebsiteImageLinkFromImageId(globalState, imageId)) ? `homepage1-banner-container full-width bg-gray ${css(styles.image)}` : 'homepage1-banner-container full-width bg-gray'}
                    src={getWebsiteImage(globalState, imageId)}
                    loading="lazy"
                    alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Banner Image'}
                />
            ) : null}
        </>
    );
};

HomePage1Banner.propTypes = {
    imageId: PropTypes.string.isRequired,
};

export default memo(HomePage1Banner);
